import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import ServiceAreas from './ServiceAreas';

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-gray-800 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              ONYXA
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Premium mobile car polishing and detailing services. Professional results at your location.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="text-gray-400 hover:text-red-500 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="text-gray-400 hover:text-red-500 transition-colors"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/services" data-testid="footer-services-link" className="block text-gray-400 hover:text-red-500 text-sm transition-colors">
                Our Services
              </Link>
              <Link to="/about" data-testid="footer-about-link" className="block text-gray-400 hover:text-red-500 text-sm transition-colors">
                About Us
              </Link>
              <Link to="/gallery" data-testid="footer-gallery-link" className="block text-gray-400 hover:text-red-500 text-sm transition-colors">
                Gallery
              </Link>
              <Link to="/booking" data-testid="footer-booking-link" className="block text-gray-400 hover:text-red-500 text-sm transition-colors">
                Book Appointment
              </Link>
            </div>
          </div>

          {/* Service Areas */}
          <div>
            <ServiceAreas compact={true} />
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm text-gray-400">
                <Phone size={18} className="flex-shrink-0" />
                <span>(929) 774-6344</span>
              </div>
              <div className="flex items-center space-x-3 text-sm text-gray-400">
                <Mail size={18} className="flex-shrink-0" />
                <span>onyxadetailing@gmail.com</span>
              </div>
            </div>
            <div className="mt-4">
              <h5 className="text-sm font-semibold mb-2">Top Services</h5>
              <div className="space-y-1 text-xs text-gray-400">
                <p>Paint Correction</p>
                <p>Ceramic Coating</p>
                <p>Interior Detailing</p>
                <p>Headlight Restoration</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} ONYXA Car Polishing & Detailing. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
